/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useEffect} from 'react'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {PasswordMeterComponent} from '../../../../_metronic/assets/ts/components'
import {useAuth} from '../core/Auth'
import {UserModel} from '../core/_models'
import {getUserByToken, register} from '../../../../Adaptor/TUBSIS'
import {TextboxWithLabel} from '../../../customPartials/formComponents/TextboxWithLabel'
import {PasswordWithLabel} from '../../../customPartials/formComponents/PasswordWithLabel'
import {TermChecker} from '../../../customPartials/formComponents/TermChecker'
import {SelectBoxWithLabel} from '../../../customPartials/formComponents/SelectBoxWithLabel'
import {DateTimePickerWithLabel} from '../../../customPartials/formComponents/DateTimePickerWithLabel'
import QuestionWithDayMonthYear from '../../../customPartials/formComponents/QuestionWithDayMonthYear'
import {Question} from '../../../../Adaptor/TUBSIS/controllers/Tests/models/testModels'
import QuestionWithDayMonthYear_ForRegister from '../../../customPartials/formComponents/QuestionWithDayMonthYear_ForRegister'
import QuestionWithDayMonthYearRoutine from '../../../customPartials/formComponents/QuestionWithDayMonthYearRoutine'

const initialValues = {
  firstname: '',
  lastname: '',
  birthDate: '',
  citizenId: '',
  email: '',
  password: '',
  changepassword: '',
  acceptTerms: false,
  gender: '',
  phone: '',
  educationStatus: '',
  currentEducation: '',
  currentEducationDesc: '',
  martialStatus: '',
  haveChild: '',
  professionStatus: false,
  profession: '',
  currentJob: '',
  currentJobDesc: '',
  financialStatus: '',
  motherEducationLevel: '',
  fatherEducationLevel: '',
  livingPlaceStatus: '',
  livingPlaceStatusDesc: '',
  firstTryAge: '',
  ageOfAddiction: '',
  lastConsumption: '',
  smokingBehavior: '',
  smokingRoutine: '',
  smokingRoutineCount: '',
  smokingQuitIsTry: '',
  smokingQuitTryCount: '',
  questionEnUzunKullanmama: '',

  questionEnUzunBirakmaGirisim: '',
  questionEnSonBirakmaGirisim: '',
}

const registrationSchema = Yup.object().shape({
  firstname: Yup.string()
    .min(3, 'Minimum 3 karakter')
    .max(50, 'Maximum 50 karakter')
    .required('Ad girilmesi gerekli'),
  email: Yup.string()
    .email('Yanlış email format')
    .min(3, 'Minimum 3 karakter')
    .max(50, 'Maximum 50 karakter')
    .required('Email girilmesi gerekli'),
  lastname: Yup.string()
    .min(2, 'Minimum 2 karakter')
    .max(50, 'Maximum 50 karakter')
    .required('Soyad girilmesi gerekli'),
  birthDate: Yup.date().max(new Date(), 'İleri bir tarih olamaz').required('Lütfen Seçim yapınız.'),
  citizenId: Yup.number()
    .min(10000000000, 'Minimum 11 karakter')
    .max(99999999999, 'Maximum 11 karakter')
    .required('TcKimlik No girilmesi gerekli'),
  password: Yup.string()
    .min(8, 'Minimum 8 karakter')
    .matches(/[A-Z]/, 'Bir büyük harf içermelidir')
    .matches(/[a-z]/, 'Bir küçük harf içermelidir')
    .matches(/[0-9]/, 'Bir rakam içermelidir')
    .matches(/[^a-zA-Z0-9]/, 'Bir özel karakter içermelidir')
    .max(50, 'Maximum 50 karakter')
    .required('Şifre girilmesi gerekli'),
  changepassword: Yup.string()
    .min(8, 'Minimum 8 karakter')
    .max(50, 'Maximum 50 karakter')
    .required('Şifre doğrulaması gerekli')
    .oneOf([Yup.ref('password')], 'Şifreler birbiriyle farklı'),
  gender: Yup.string().required('Cinsiyetinizi girmeniz gerekmektedir'),
  phone: Yup.number()
    .min(5000000000, 'Telefon Numaranızı 5xxxxxxxxx şeklinde 10 hane olarak girmeniz gerekmektedir')
    .typeError('Telefon Numaranızı 5xxxxxxxxx şeklinde 10 hane olarak girmeniz gerekmektedir')
    .max(5999999999, 'Telefon Numaranızı 5xxxxxxxxx şeklinde 10 hane olarak girmeniz gerekmektedir')
    .required('Telefon Numaranızı 5xxxxxxxxx şeklinde 10 hane olarak girmeniz gerekmektedir'),
  educationStatus: Yup.string().required('Eğitim Durumunuzu girmeniz gerekmektedir.'),
  currentEducation: Yup.string().required('Lütfen Seçim yapınız.'),
  currentEducationDesc: Yup.string().when('currentEducation', ([currentEducation], schema) => {
    return currentEducation == '10008'
      ? schema.min(3, 'Minimum 3 karakter').required('Eğitim Bilginizi girmeniz gerekmektedir')
      : schema
  }),
  martialStatus: Yup.string().required('Medeni Durumunuzu girmeniz gerekmektedir'),
  haveChild: Yup.bool().required('Çocuğunuzun olup olmadığını gerekmektedir'),
  professionStatus: Yup.bool().required('Mesleğinizin olup olmadığını gerekmektedir'),
  profession: Yup.string().when('professionStatus', ([professionStatus], schema) => {
    return professionStatus ? schema.required('Mesleğinizi girmeniz gerekmektedir') : schema
  }),
  currentJob: Yup.string().required('Lütfen Seçim yapınız.'),
  currentJobDesc: Yup.string().when('currentJob', ([currentJob], schema) => {
    return currentJob == '12006'
      ? schema.min(3, 'Minimum 3 karakter').required('Mevcut iş durumunuzu girmeniz gerekmektedir')
      : schema
  }),
  financialStatus: Yup.string().required('Lütfen Seçim yapınız.'),
  motherEducationLevel: Yup.string().required('Lütfen Seçim yapınız.'),
  fatherEducationLevel: Yup.string().required('Lütfen Seçim yapınız.'),
  livingPlaceStatus: Yup.string().required('Lütfen Seçim yapınız.'),
  livingPlaceStatusDesc: Yup.string().when('livingPlaceStatus', ([livingPlaceStatus], schema) => {
    //debugger
    return livingPlaceStatus == '14008'
      ? schema
          .min(3, 'Minimum 3 karakter')
          .required('Mevcut yaşadığınız yeri girmeniz gerekmektedir')
      : schema
  }),
  firstTryAge: Yup.number()
    .typeError('Lütfen geçerli bir yaş giriniz')
    .min(1, 'Lütfen geçerli bir yaş giriniz')
    .max(80, 'Lütfen geçerli bir yaş giriniz')
    .required('Lütfen ilk deneme yaşınızı giriniz.'),
  ageOfAddiction: Yup.number()
    .typeError('Lütfen geçerli bir yaş giriniz')
    .min(1, 'Lütfen geçerli bir yaş giriniz')
    .max(80, 'Lütfen geçerli bir yaş giriniz')
    .required('Lütfen ilk düzenli kullanma yaşınızı giriniz.'),
  lastConsumption: Yup.date()
    .max(new Date(), 'İleri bir tarih olamaz')
    .required('Lütfen Seçim yapınız.'),
  smokingBehavior: Yup.string().required('Lütfen Seçim yapınız.'),
  smokingRoutine: Yup.string().when('smokingBehavior', ([smokingBehavior], schema) => {
    return smokingBehavior == 18002 ? schema.required('Lütfen Seçim yapınız.') : schema
  }),
  smokingRoutineCount: Yup.number().when('smokingBehavior', ([smokingBehavior], schema) => {
    return smokingBehavior == 18002
      ? schema
          .typeError('Lütfen geçerli bir rakam giriniz')
          .min(1, 'Lütfen geçerli bir rakam giriniz')
          .max(1000, 'Lütfen geçerli bir rakam giriniz')
          .required('Lütfen Seçim yapınız.')
      : schema
  }),
  smokingQuitIsTry: Yup.string().required('Lütfen Seçim yapınız.'),
  smokingQuitTryCount: Yup.number().when('smokingQuitIsTry', ([smokingQuitIsTry], schema) => {
    return smokingQuitIsTry == 20003
      ? schema
          .typeError('Lütfen geçerli bir rakam giriniz')
          .min(1, 'Lütfen geçerli bir rakam giriniz')
          .max(1000, 'Lütfen geçerli bir rakam giriniz')
          .required('Lütfen Seçim yapınız.')
      : schema
  }),
  questionEnUzunKullanmama: Yup.number().when('smokingQuitIsTry', ([smokingQuitIsTry], schema) => {
    return smokingQuitIsTry == 20003
      ? schema
          .min(1, 'Lütfen geçerli bir rakam giriniz')
          .max(30000, 'Lütfen geçerli bir rakam giriniz')
          .required('Lütfen Seçim yapınız.')
      : schema
  }),
  questionEnUzunBirakmaGirisim: Yup.number().when(
    'smokingQuitIsTry',
    ([smokingQuitIsTry], schema) => {
      return smokingQuitIsTry == 20003
        ? schema
            .min(1, 'Lütfen geçerli bir rakam giriniz')
            .max(30000, 'Lütfen geçerli bir rakam giriniz')
            .required('Lütfen Seçim yapınız.')
        : schema
    }
  ),
  questionEnSonBirakmaGirisim: Yup.number().when(
    'smokingQuitIsTry',
    ([smokingQuitIsTry], schema) => {
      return smokingQuitIsTry == 20003
        ? schema
            .min(0, 'Lütfen geçerli bir sayı giriniz')
            .max(30000, 'Lütfen geçerli bir sayı giriniz')
            .required('Lütfen Seçim yapınız.')
        : schema
    }
  ),
  acceptTerms: Yup.bool().required('Kaydolma koşullarını kabul etmeniz gerekli'),
})

export function Registration() {
  const genderList = [
    {key: 8001, value: 'Kadın'},
    {key: 8002, value: 'Erkek'},
    {key: 8003, value: 'Diğer'},
  ]
  const educationStatusList = [
    {key: 9001, value: 'Lisansüstü Mezunu'},
    {key: 9002, value: 'Lisans Mezunu'},
    {key: 9003, value: 'Önlisans Mezunu'},
    {key: 9004, value: 'Lise Mezunu'},
    {key: 9005, value: 'Ortaokul Mezunu'},
    {key: 9006, value: 'İlkokul Mezunu'},
    {key: 9007, value: 'Okur/Yazar'},
    {key: 9008, value: 'Okur/Yazar Değil'},
  ]
  const currentEducationList = [
    {key: 10001, value: 'Öğrenci Değilim'},
    {key: 10002, value: 'Lisansüstü'},
    {key: 10003, value: 'Lisans'},
    {key: 10004, value: 'Önlisans'},
    {key: 10005, value: 'Lise'},
    {key: 10006, value: 'Ortaokul'},
    {key: 10007, value: 'İlkokul'},
    {key: 10008, value: 'Diğer'},
  ]
  const martialStatusList = [
    {key: 11001, value: 'Bekar'},
    {key: 11002, value: 'Evli'},
    {key: 11003, value: 'Boşanmış'},
    {key: 11005, value: 'Ayrı'},
    {key: 11004, value: 'Dul (eşi vefat etmiş)'},
  ]
  const currentJobList = [
    {key: 12001, value: 'Düzenli işim yok'},
    {key: 12002, value: 'Memur'},
    {key: 12003, value: 'İşçi'},
    {key: 12004, value: 'Emekli'},
    {key: 12005, value: 'İşveren'},
    {key: 12006, value: 'Diğer'},
  ]
  const financialStatusList = [
    {key: 13001, value: 'Çok Düşük'},
    {key: 13002, value: 'Düşük'},
    {key: 13003, value: 'Orta'},
    {key: 13004, value: 'Yüksek'},
    {key: 13005, value: 'Çok Yüksek'},
  ]
  const livingPlaceList = [
    {key: 14001, value: 'Yurtta tek başıma'},
    {key: 14002, value: 'Yurtta arkadaşımla'},
    {key: 14003, value: 'Evde tek başıma'},
    {key: 14004, value: 'Evde arkadaşımla'},
    {key: 14005, value: 'Evde eşim ve (varsa) çocuklarımla'},
    {key: 14006, value: 'Evde annem/babam/kardeşimle'},
    {key: 14007, value: 'Evde akrabamla'},
    {key: 14008, value: 'Diğer'},
  ]
  const YesNoList = [
    {key: false, value: 'Hayır'},
    {key: true, value: 'Evet'},
  ]
  const SmokingBehavior = [
    {key: 18001, value: 'Düzenli olarak sigara içerim (haftada en az 3 adet ya da daha fazla)'},
    {key: 18002, value: 'Ara sıra sigara içerim (haftada 2 adet veya daha az)'},
    {key: 18003, value: 'Önceden sigara içerdim.'},
    {key: 18004, value: 'Yaşamım boyunca en fazla birkaç kere sigara içmeyi denedim.'},
  ]
  const SmokingRoutine = [
    {key: 19001, value: 'Ayda'},
    {key: 19002, value: 'Haftada'},
    {key: 19003, value: 'Günde'},
  ]
  const SmokingQuitIsTry = [
    // {key: 20001, value: 'Girişimim Olmadı'},
    {key: 20002, value: 'Hayır'},
    {key: 20003, value: 'Evet'},
  ]
  const [loading, setLoading] = useState(false)
  const {saveAuth, setCurrentUser} = useAuth()
  const formik = useFormik({
    initialValues,
    validationSchema: registrationSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      //debugger
      setLoading(true)
      try {
        //debugger
        const auth = await register({
          Name: values.firstname,
          Surname: values.lastname,
          CitizenId: +values.citizenId,
          BirthDate: new Date(values.birthDate),
          Email: values.email,
          Password: values.password,
          Gender: +values.gender,
          MobilePhones: values.phone,
          EducationLevel: +values.educationStatus,
          CurrentEducation: +values.currentEducation,
          CurrentEducationDesc: values.currentEducationDesc,
          MartialStatus: +values.martialStatus,
          HaveChild: values.haveChild == 'true',
          Profession: values.professionStatus ? values.profession : '',
          CurrentJob: +values.currentJob,
          CurrentJobDesc: values.currentJobDesc,
          FinancialSituation: +values.financialStatus,
          MotherEducationLevel: +values.motherEducationLevel,
          FatherEducationLevel: +values.fatherEducationLevel,
          LivingPlaceStatus: +values.livingPlaceStatus,
          LivingPlaceStatusDesc: values.livingPlaceStatusDesc,
          FirstTryAge: +values.firstTryAge,
          AgeOfAddiction: +values.ageOfAddiction,
          LastConsumption: new Date(values.lastConsumption),
          SmokingBehavior: +values.smokingBehavior,
          SmokingRoutine: +values.smokingRoutine,
          SmokingRoutineCount: +values.smokingRoutineCount,
          SmokingQuitIsTry: +values.smokingQuitIsTry,
          SmokingQuitTryCount: +values.smokingQuitTryCount,
          QuestionEnUzunKullanmama: +values.questionEnUzunKullanmama,
          QuestionEnUzunBirakmaGirisim: +values.questionEnUzunBirakmaGirisim,
          QuestionEnSonBirakmaGirisim: +values.questionEnSonBirakmaGirisim,
          FullName: values.firstname + ' ' + values.lastname,
        })
        //debugger
        saveAuth({
          api_token: auth.data ? auth.data.token : '',
          refreshToken: auth.data ? auth.data.refreshToken : '',
        })
        const result = await getUserByToken(auth.data ? auth.data.token : '')
        if (!result || !result.data || !result.success) {
          saveAuth(undefined)
          setStatus('Girilen Bilgilerde Bir Hata Var')
          setSubmitting(false)
          setLoading(false)
          return
        }

        const data = result.data

        setCurrentUser(() => {
          const temp: UserModel = {
            id: data.userId,
            email: data.email,
            first_name: data.firstName,
            last_name: data.lastName,
            password: data.password,
            username: data.email,
            leadershipCourses: data.leadershipCourses,
          }
          return temp
        })
        window.location.reload()
      } catch (error) {
        console.error(error)
        saveAuth(undefined)
        setStatus('Girilen Bilgilerde Bir Hata Var')
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  useEffect(() => {
    PasswordMeterComponent.bootstrap()
  }, [])

  return (
    <form
      className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
      noValidate
      id='kt_login_signup_form'
      onSubmit={formik.handleSubmit}
    >
      {/* begin::Heading */}
      <div className='text-center mb-11'>
        {/* begin::Title */}
        <h1 className='text-dark fw-bolder mb-3'>Kaydol</h1>
        {/* end::Title */}
        {/* 
        <div className='text-gray-500 fw-semibold fs-6'>Your Social Campaigns</div> */}
      </div>
      {/* end::Heading */}
      {/* begin::Login options */}
      <div className='row g-3 mb-9'>
        {/* begin::Col */}
        <div className='col-md-6'>
          {/* begin::Google link */}
          {/* <a
            href='#'
            className='btn btn-flex btn-outline btn-text-gray-700 btn-active-color-primary bg-state-light flex-center text-nowrap w-100'
          >
            <img
              alt='Logo'
              src={toAbsoluteUrl('/media/svg/brand-logos/google-icon.svg')}
              className='h-15px me-3'
            />
            Sign in with Google
          </a> */}
          {/* end::Google link */}
        </div>
        {/* end::Col */}

        {/* begin::Col */}
        <div className='col-md-6'>
          {/* begin::Google link */}
          {/* <a
            href='#'
            className='btn btn-flex btn-outline btn-text-gray-700 btn-active-color-primary bg-state-light flex-center text-nowrap w-100'
          >
            <img
              alt='Logo'
              src={toAbsoluteUrl('/media/svg/brand-logos/apple-black.svg')}
              className='theme-light-show h-15px me-3'
            />
            <img
              alt='Logo'
              src={toAbsoluteUrl('/media/svg/brand-logos/apple-black-dark.svg')}
              className='theme-dark-show h-15px me-3'
            />
            Sign in with Apple
          </a> */}
          {/* end::Google link */}
        </div>
        {/* end::Col */}
      </div>
      {/* end::Login options */}
      {/* <div className='separator separator-content my-14'>
        <span className='w-125px text-gray-500 fw-semibold fs-7'>Or with email</span>
      </div> */}

      {/* begin::Form group Firstname */}
      <TextboxWithLabel
        label='Ad'
        placeholder='Ad'
        props={formik.getFieldProps('firstname')}
        touched={formik.touched.firstname}
        errors={formik.errors.firstname}
      />
      <TextboxWithLabel
        label='Soyad'
        placeholder='Soyad'
        props={formik.getFieldProps('lastname')}
        touched={formik.touched.lastname}
        errors={formik.errors.lastname}
      />
      <TextboxWithLabel
        label='TC Kimlik No'
        placeholder='TC Kimlik No'
        props={formik.getFieldProps('citizenId')}
        touched={formik.touched.citizenId}
        errors={formik.errors.citizenId}
      />
      <DateTimePickerWithLabel
        label='Doğum Tarihiniz'
        props={formik.getFieldProps('birthDate')}
        touched={formik.touched.birthDate}
        errors={formik.errors.birthDate}
      />
      <TextboxWithLabel
        label='Email'
        placeholder='Email'
        props={formik.getFieldProps('email')}
        touched={formik.touched.email}
        errors={formik.errors.email}
      />
      <PasswordWithLabel
        passwordLabel='Şifre'
        passwordPlaceholder='Şifre'
        passwordProps={formik.getFieldProps('password')}
        passwordTouched={formik.touched.password}
        passwordErrors={formik.errors.password}
        isConfirmationActive={true}
        passwordStrictLabel='Minimum 8 haneden oluşan karakter, harfler karışık bir şekilde bir şifre belirleyiniz.'
        confirmLabel='Şifre Doğrula'
        confirmPlaceholder='Şifre Doğrula'
        confirmProps={formik.getFieldProps('changepassword')}
        confirmTouched={formik.touched.changepassword}
        confirmErrors={formik.errors.changepassword}
      />
      <SelectBoxWithLabel
        id='gender'
        label='Cinsiyetiniz'
        props={formik.getFieldProps('gender')}
        errors={formik.errors.gender}
        touched={formik.touched.gender}
        options={genderList}
      />
      <TextboxWithLabel
        label='Cep Telefonu'
        placeholder='Cep Telefonu'
        props={formik.getFieldProps('phone')}
        touched={formik.touched.phone}
        errors={formik.errors.phone}
      />
      <SelectBoxWithLabel
        id='educationStatus'
        label='Eğitim Düzeyiniz Nedir?'
        props={formik.getFieldProps('educationStatus')}
        errors={formik.errors.educationStatus}
        touched={formik.touched.educationStatus}
        options={educationStatusList.filter((x) => x.key != 9007)}
      />
      <SelectBoxWithLabel
        id='currentEducation'
        label='Öğrenci misiniz? Öğrenciyseniz devam etmekte olduğunuz eğitim programınız nedir?'
        props={formik.getFieldProps('currentEducation')}
        errors={formik.errors.currentEducation}
        touched={formik.touched.currentEducation}
        options={currentEducationList}
      />
      {formik.values.currentEducation == '10008' && (
        <TextboxWithLabel
          label='Önceki Soruda Eğitim Durumunuzu Diğer Seçtiniz'
          placeholder='Lütfen Belirtiniz... '
          props={formik.getFieldProps('currentEducationDesc')}
          touched={formik.touched.currentEducationDesc}
          errors={formik.errors.currentEducationDesc}
        />
      )}
      <SelectBoxWithLabel
        id='martialStatus'
        label='Medeni durumunuz nedir?'
        props={formik.getFieldProps('martialStatus')}
        errors={formik.errors.martialStatus}
        touched={formik.touched.martialStatus}
        options={martialStatusList}
      />
      <SelectBoxWithLabel
        id='haveChild'
        label='Çocuğunuz var mı?'
        props={formik.getFieldProps('haveChild')}
        errors={formik.errors.haveChild}
        touched={formik.touched.haveChild}
        options={YesNoList}
      />
      <SelectBoxWithLabel
        id='professionStatus'
        label='Mesleğiniz var mı?'
        props={formik.getFieldProps('professionStatus')}
        errors={formik.errors.professionStatus}
        touched={formik.touched.professionStatus}
        options={YesNoList}
      />

      {!!formik.values.professionStatus ? ( //values['professionStatus'] ? (
        <TextboxWithLabel
          label='Mesleğiniz Nedir? '
          placeholder='Mesleğiniz'
          props={formik.getFieldProps('profession')}
          touched={formik.touched.profession}
          errors={formik.errors.profession}
        />
      ) : (
        <></>
      )}
      {/* {!formik.values.professionStatus == false && ( //values['professionStatus'] ? (
        <TextboxWithLabel
          label='Mesleğiniz Nedir? '
          placeholder='Mesleğiniz'
          props={formik.getFieldProps('profession')}
          touched={formik.touched.profession}
          errors={formik.errors.profession}
        />
      )} */}
      <SelectBoxWithLabel
        id='currentJob'
        label='Düzenli işiniz var mı?Varsa, güncel işinizdeki ya da son çalıştığınız yerdeki pozisyonunuz nedir?'
        props={formik.getFieldProps('currentJob')}
        errors={formik.errors.currentJob}
        touched={formik.touched.currentJob}
        options={currentJobList}
      />
      {formik.values.currentJob == '12006' && (
        <TextboxWithLabel
          label='Önceki Soruda İş Durumunuzu Diğer Seçtiniz'
          placeholder='Lütfen Belirtiniz... '
          props={formik.getFieldProps('currentJobDesc')}
          touched={formik.touched.currentJobDesc}
          errors={formik.errors.currentJobDesc}
        />
      )}
      <SelectBoxWithLabel
        id='financialStatus'
        label='Aylık gelir durumunuzu nasıl tanımlarsınız?'
        props={formik.getFieldProps('financialStatus')}
        errors={formik.errors.financialStatus}
        touched={formik.touched.financialStatus}
        options={financialStatusList}
      />
      <SelectBoxWithLabel
        id='motherEducationLevel'
        label='Annenizin eğitim düzeyi nedir?'
        props={formik.getFieldProps('motherEducationLevel')}
        errors={formik.errors.motherEducationLevel}
        touched={formik.touched.motherEducationLevel}
        options={educationStatusList}
      />
      <SelectBoxWithLabel
        id='fatherEducationLevel'
        label='Babanızın eğitim düzeyi nedir?'
        props={formik.getFieldProps('fatherEducationLevel')}
        errors={formik.errors.fatherEducationLevel}
        touched={formik.touched.fatherEducationLevel}
        options={educationStatusList}
      />
      <SelectBoxWithLabel
        id='livingPlaceStatus'
        label='Şu anda yaşadığınız alanı lütfen aşağıda seçiniz.'
        props={formik.getFieldProps('livingPlaceStatus')}
        errors={formik.errors.livingPlaceStatus}
        touched={formik.touched.livingPlaceStatus}
        options={livingPlaceList}
      />
      {formik.values.livingPlaceStatus == '14008' && (
        <TextboxWithLabel
          label='Önceki Soruda Yaşadığınız Yerin Durumunu Diğer Seçtiniz'
          placeholder='Lütfen Belirtiniz... '
          props={formik.getFieldProps('livingPlaceStatusDesc')}
          touched={formik.touched.livingPlaceStatusDesc}
          errors={formik.errors.livingPlaceStatusDesc}
        />
      )}
      <TextboxWithLabel
        label='Sigara içmeyi ilk denediğinizde kaç yaşındaydınız?'
        placeholder='... yaşındaydım'
        props={formik.getFieldProps('firstTryAge')}
        touched={formik.touched.firstTryAge}
        errors={formik.errors.firstTryAge}
      />
      <TextboxWithLabel
        label='Sigarayı ilk düzenli (haftada en az 3 kere ya da daha fazla sıklıkta) kullanmaya başladığınızda kaç yaşındaydınız?'
        placeholder='... yaşındaydım'
        props={formik.getFieldProps('ageOfAddiction')}
        touched={formik.touched.ageOfAddiction}
        errors={formik.errors.ageOfAddiction}
      />

      <DateTimePickerWithLabel
        label='En son ne zaman sigara içtiniz? (en az 1 kere içine çekme dahi olsa)'
        props={formik.getFieldProps('lastConsumption')}
        touched={formik.touched.lastConsumption}
        errors={formik.errors.lastConsumption}
      />
      <SelectBoxWithLabel
        id='smokingBehavior'
        label='Sigara içme davranışınız hakkında aşağıda size en uygun olan seçeneği lütfen işaretleyiniz:'
        props={formik.getFieldProps('smokingBehavior')}
        errors={formik.errors.smokingBehavior}
        touched={formik.touched.smokingBehavior}
        options={SmokingBehavior}
      />
      {formik.values.smokingBehavior == '18002' && (
        <QuestionWithDayMonthYearRoutine
          label={'Ara sıra içiyorsanız; sigara içme sıklığınızı lütfen tanımlayınız.'}
          id1={'smokingRoutine'}
          props1={formik.getFieldProps('smokingRoutine')}
          errors1={formik.errors.smokingRoutine}
          touched1={formik.touched.smokingRoutine}
          options={SmokingRoutine}
          id2={'smokingRoutineCount'}
          props2={formik.getFieldProps('smokingRoutineCount')}
          errors2={formik.errors.smokingRoutineCount}
          touched2={formik.touched.smokingRoutineCount}
          placeholder2=' ... adet sigara içerim.'
        />
      )}
      <SelectBoxWithLabel
        id='smokingQuitIsTry'
        label='Hiç sigara içmeyi bırakma girişiminiz oldu mu?'
        props={formik.getFieldProps('smokingQuitIsTry')}
        errors={formik.errors.smokingQuitIsTry}
        touched={formik.touched.smokingQuitIsTry}
        options={SmokingQuitIsTry}
      />
      {formik.values.smokingQuitIsTry == '20003' && (
        <>
          <TextboxWithLabel
            label='Bırakma girişiminiz oldu ise; Daha önce kaç kere sigarayı bırakmayı denediniz/bıraktınız?'
            placeholder='... kere denedim/bıraktım.'
            props={formik.getFieldProps('smokingQuitTryCount')}
            touched={formik.touched.smokingQuitTryCount}
            errors={formik.errors.smokingQuitTryCount}
          />
          <QuestionWithDayMonthYear_ForRegister
            id={'questionEnUzunKullanmama'}
            label={
              'Sigarayı kullanmaya başladıktan sonraki dönemde yaşamınız boyunca en uzun ne kadar süre sigara hiç kullanmadınız?'
            }
            answerSuffix=' sigara içmedim.'
            touched={formik.touched.questionEnUzunKullanmama}
            errors={formik.errors.questionEnUzunKullanmama}
            setFieldValue={formik.setFieldValue}
            setFieldTouched={formik.setFieldTouched}
          />
          <QuestionWithDayMonthYear_ForRegister
            id={'questionEnUzunBirakmaGirisim'}
            label={
              'Yaşamınız boyunca en uzun süreli sigara bırakma girişiminiz ne kadar devam etti?'
            }
            answerSuffix=' sigara içmedim.'
            touched={formik.touched.questionEnUzunBirakmaGirisim}
            errors={formik.errors.questionEnUzunBirakmaGirisim}
            setFieldValue={formik.setFieldValue}
            setFieldTouched={formik.setFieldTouched}
          />
          <QuestionWithDayMonthYear_ForRegister
            id={'questionEnSonBirakmaGirisim'}
            label={'Sigarayı bırakmaya yönelik son girişiminizde ne kadar süre sigara içmediniz?'}
            answerSuffix=' sigara içmedim.'
            touched={formik.touched.questionEnSonBirakmaGirisim}
            errors={formik.errors.questionEnSonBirakmaGirisim}
            setFieldValue={formik.setFieldValue}
            setFieldTouched={formik.setFieldTouched}
          />
        </>
      )}
      <TermChecker
        text='Üyelik Koşullarını Kabul Ediyorum'
        props={formik.getFieldProps('acceptTerms')}
        errors={formik.errors.acceptTerms}
        touched={formik.touched.acceptTerms}
        modalBackButtonText='Back'
        modalTitle='Terms'
        fileBase64={toAbsoluteUrl('/media/onay/onay.pdf')}
      />
      {formik.status && (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      )}
      {/* begin::Form group */}
      <div className='text-center'>
        <button
          type='submit'
          id='kt_sign_up_submit'
          className='btn btn-lg btn-primary w-100 mb-5'
          disabled={formik.isSubmitting || !formik.isValid || !formik.values.acceptTerms}
        >
          {!loading && <span className='indicator-label'>Kaydol</span>}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Lütfen Bekleyiniz...{' '}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
        <Link to='/auth/login'>
          <button
            type='button'
            id='kt_login_signup_form_cancel_button'
            className='btn btn-lg btn-light-primary w-100 mb-5'
          >
            Vazgeç
          </button>
        </Link>
      </div>
    </form>
  )
}
